"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDeleteAddress = void 0;
var api_utils_1 = require("@moralisweb3/api-utils");
var StreamNetwork_1 = require("../utils/StreamNetwork");
var IncorrectNetworkError_1 = require("../utils/IncorrectNetworkError");
var common_streams_utils_1 = require("@moralisweb3/common-streams-utils");
var makeDeleteAddressAptosStream = function (core, baseUrl, _a) {
    var networkType = _a.networkType, options = __rest(_a, ["networkType"]);
    return new api_utils_1.OperationResolver(common_streams_utils_1.deleteAddressAptosOperation, baseUrl, core).fetch(options);
};
var makeDeleteAddressEvmStream = function (core, baseUrl, _a) {
    var networkType = _a.networkType, options = __rest(_a, ["networkType"]);
    return new api_utils_1.OperationResolver(common_streams_utils_1.deleteAddressEvmOperation, baseUrl, core).fetch(options);
};
var makeDeleteAddress = function (core, baseUrl) {
    return (function (deleteAddressOptions) {
        switch (deleteAddressOptions.networkType) {
            case StreamNetwork_1.StreamNetwork.APTOS:
                return makeDeleteAddressAptosStream(core, baseUrl, deleteAddressOptions);
            case StreamNetwork_1.StreamNetwork.EVM:
                return makeDeleteAddressEvmStream(core, baseUrl, deleteAddressOptions);
            default:
                if (deleteAddressOptions.networkType === undefined) {
                    return makeDeleteAddressEvmStream(core, baseUrl, deleteAddressOptions);
                }
                throw new IncorrectNetworkError_1.IncorrectNetworkError(deleteAddressOptions.networkType);
        }
    });
};
exports.makeDeleteAddress = makeDeleteAddress;
//# sourceMappingURL=deleteAddress.js.map